import { createContext } from "react";
const ButtonNestingContext = createContext(!1);
export { ButtonNestingContext };